import React from 'react';
import styles from './Matrices.module.css';

const MatrixStatistics = ({ statistics, loading }) => {
    if (loading) {
        return (
            <div className={styles.statisticsLoading}>
                <div className={styles.spinner}></div>
                <span>Loading statistics...</span>
            </div>
        );
    }

    return (
        <div className={styles.statisticsContainer}>
            <div className={styles.statisticsHeader}>
                <h3>Matrices Overview</h3>
                <p>Statistics about matrices in the system</p>
            </div>
            <div className={styles.statisticsGrid}>
                <div className={styles.statCard}>
                    <div className={styles.statHeader}>
                        <h4 className={styles.statLabel}>Total Matrices</h4>
                        <span className={styles.statValue}>{statistics.total}</span>
                    </div>
                    <div className={styles.statBar}>
                        <div 
                            className={styles.statBarFill}
                            style={{ width: '100%' }}
                        />
                    </div>
                </div>
                
                <div className={styles.statCard}>
                    <div className={styles.statHeader}>
                        <h4 className={styles.statLabel}>Active Matrices</h4>
                        <span className={styles.statValue}>{statistics.active}</span>
                    </div>
                    <div className={styles.statBar}>
                        <div 
                            className={styles.statBarFill}
                            style={{ 
                                width: `${statistics.total > 0 ? (statistics.active / statistics.total * 100) : 0}%`,
                                backgroundColor: 'var(--success-color, #28a745)'
                            }}
                        />
                    </div>
                </div>

                <div className={styles.statCard}>
                    <div className={styles.statHeader}>
                        <h4 className={styles.statLabel}>Liquid Matrices</h4>
                        <span className={styles.statValue}>{statistics.liquid || 0}</span>
                    </div>
                    <div className={styles.statBar}>
                        <div 
                            className={styles.statBarFill}
                            style={{ 
                                width: `${statistics.total > 0 ? ((statistics.liquid || 0) / statistics.total * 100) : 0}%`,
                                backgroundColor: '#0096c7'
                            }}
                        />
                    </div>
                </div>

                <div className={styles.statCard}>
                    <div className={styles.statHeader}>
                        <h4 className={styles.statLabel}>Solid Matrices</h4>
                        <span className={styles.statValue}>{statistics.solid || 0}</span>
                    </div>
                    <div className={styles.statBar}>
                        <div 
                            className={styles.statBarFill}
                            style={{ 
                                width: `${statistics.total > 0 ? ((statistics.solid || 0) / statistics.total * 100) : 0}%`,
                                backgroundColor: '#8b4513'
                            }}
                        />
                    </div>
                </div>

                <div className={styles.statCard}>
                    <div className={styles.statHeader}>
                        <h4 className={styles.statLabel}>Gas Matrices</h4>
                        <span className={styles.statValue}>{statistics.gas || 0}</span>
                    </div>
                    <div className={styles.statBar}>
                        <div 
                            className={styles.statBarFill}
                            style={{ 
                                width: `${statistics.total > 0 ? ((statistics.gas || 0) / statistics.total * 100) : 0}%`,
                                backgroundColor: '#90e0ef'
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MatrixStatistics;
